import React from 'react';
import styles from './TextDivider.module.scss';

export interface TextDividerProps {
  text: string;
}

const TextDivider: React.FC<TextDividerProps> = ({ text }) => {
  return (
    <div className={styles['divider-container']} data-testid="divider">
      {text && (
        <span className={styles['divider-text']} data-testid="divider-text">
          {text}
        </span>
      )}
    </div>
  );
};

export default TextDivider;
